import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import PanelsHeader from "features/Contactos/components/PanelsHeader"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { useTranslation } from "react-i18next"
import { globalSelector } from "routes/globalSlice"
import * as Yup from "yup"

const FormContactoPreferencias = ({
  values,
  setFieldValue,
  handleSubmit,
  isValid,
  dirty,
  ...props
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { formasPago } = useSelector(globalSelector)

  const formattedOptions = formasPago?.map((pago: $TSMigrationFixMe) => ({
    label: pago.description,
    value: pago.id,
  }))

  return (
    <>
      <PanelsHeader
        title={t("contactos.editar.dataAdvance.menuPreference")}
        handleSubmit={handleSubmit}
        disabled={!(isValid && dirty)}
      />
      <section className='contactos-preferencias__doble-field'>
        <div className='text-left contactos-preferencias__input-container'>
          <label className='text-left'>
            {t("contactos.editar.dataAdvance.paymentFormLabel")}
          </label>
          <Dropdown
            value={values.formaPago}
            options={formattedOptions}
            onChange={(e) => setFieldValue("formaPago", e.value)}
            // @ts-expect-error TS(2769): No overload matches this call.
            placeholder={t("contactos.editar.dataAdvance.placeholderPayment")}
            className='rounded-none w-100 p-input text p-component'
          />
        </div>
        <div className='text-left contactos-preferencias__input-container'>
          <label className='text-left'>
            {t("contactos.editar.dataAdvance.maturityLabel")}
          </label>
          <FormikInputNumber name='vencimientoDias' />
        </div>
      </section>
      <section className='contactos-preferencias__doble-field'>
        <div className='text-left contactos-preferencias__input-container'>
          <label className='text-left'>
            {t("contactos.editar.dataAdvance.discountLabel")}
          </label>
          <FormikInputNumber name='descuento' />
        </div>
        <div className='text-left contactos-preferencias__input-container'>
          <label className='text-left'>
            {t("contactos.editar.dataAdvance.paymentDaysLabel")}
          </label>
          <FormikInputNumber
            name='diaDePago'
            {...props}
            max={50000}
          />
        </div>
      </section>

      <section className='contactos-preferencias__doble-field'>
        <div className='text-left contactos-preferencias__input-container'>
          <label className='text-left'>
            {t("contactos.editar.dataAdvance.referenceLabel")}
          </label>
          <FormikInputText name='referencia' />
        </div>
        <div className='text-left contactos-preferencias__input-container'>
          <label className='text-left'>
            {t("contactos.editar.dataAdvance.delegationLabel")}
          </label>
          <FormikInputText name='delegacion' />
        </div>
      </section>
    </>
  )
}

export const validateFn = (
  t: $TSMigrationFixMe,
  { diaDePago, descuento }: $TSMigrationFixMe
) => {
  const errors = {}

  if (descuento < 0) {
    // @ts-expect-error TS(2339): Property 'descuento' does not exist on type '{}'.
    errors.descuento = `${t("errors.discountPositive")}`
  }
  if (diaDePago >= 32 || (diaDePago < 1 && diaDePago)) {
    // @ts-expect-error TS(2339): Property 'diaDePago' does not exist on type '{}'.
    errors.diaDePago = `${t("errors.selectedDayValid")}`
  }
  return errors
}

export const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    vencimientoDias: Yup.number()
      .moreThan(1, t("errors.selectedNumValid"))
      .nullable(true),
    diaDePago: Yup.number().nullable(),
    descuento: Yup.number()
      .positive(t("errors.selectedNumValid"))
      .nullable(true),
    referencia: Yup.string().nullable(true),
    delegacion: Yup.string().nullable(true),
  })

const Form = withFormik({
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data }) => {
    return {
      delegacion: data?.delegacion,
      descuento: data?.descuento,
      diaDePago: data?.diaDePago,
      formaPago: data?.formaPago,
      referencia: data?.referencia,
      vencimientoDias: data?.vencimientoDias,
    }
  },
  // @ts-expect-error TS(2339): Property 't' does not exist on type '{}'.
  validate: (rowData, { t }) => validateFn(t, rowData),
  enableReinitialize: true,
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'updateData' does not exist on type 'obje...
    props.updateData(values)
  },
})(FormContactoPreferencias)

export default Form
